import { SVGProps } from "react";

type TProps = SVGProps<SVGSVGElement> & {
  size?: "small" | "normal";
};

export function LogoSvg({ size = "normal", ...props }: TProps) {
  if (size === "small") {
    return (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M11.6 20H19.3L11.9 5.5L3.8 21.5H2L11.3 3.1V3H12.5L21.8 21.5H11L11.6 20Z" fill="#18181B" />
      </svg>
    );
  }

  return (
    <svg width="132" height="16" viewBox="0 0 132 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Frame" clipPath="url(#clip0_1173_70151)">
        <g id="Clip path group">
          <mask id="mask0_1173_70151" maskUnits="userSpaceOnUse" x="0" y="0" width="132" height="16">
            <g id="clip0_5172_12785">
              <path id="Vector" d="M131.583 0H0V15.864H131.583V0Z" fill="white" />
            </g>
          </mask>
          <g mask="url(#mask0_1173_70151)">
            <g id="Logo">
              <g id="Rectangle 3822">
                <path id="Vector_2" d="M1.20325 0.407349H0.206726V15.456H1.20325V0.407349Z" fill="#303239" />
                <path
                  id="Vector_2_2"
                  d="M1.40921 15.646H0V0.218018H1.40921V15.646ZM0.412681 15.2667H0.996527V0.597351H0.412681V15.2667Z"
                  fill="#303239"
                />
              </g>
              <g id="Path 21360">
                <path
                  id="Vector_3"
                  d="M7.68578 15.4567H6.68927V0.407349H7.56756L19.193 13.8207V0.407349H20.1895V15.456H19.3127L7.68578 2.04335V15.4567Z"
                  fill="#303239"
                />
                <path
                  id="Vector_4"
                  d="M20.3947 15.646H19.2126L19.1509 15.5747L7.89174 2.58602V15.6467H6.48181V0.218018H7.66545L7.7271 0.289351L18.9848 13.278V0.218018H20.394V15.646H20.3947ZM19.4113 15.2667H19.9821V0.597351H19.3982V14.3633L7.46745 0.597351H6.89522V15.2667H7.47978V1.50135L19.412 15.2673L19.4113 15.2667Z"
                  fill="#303239"
                />
              </g>
              <g id="Path 21361">
                <path
                  id="Vector_5"
                  d="M26.6727 15.4567H25.6762V0.407349H26.5545L38.1799 13.8207V0.407349H39.1765V15.456H38.2989L26.6727 2.04335V15.4567Z"
                  fill="#303239"
                />
                <path
                  id="Vector_6"
                  d="M39.3824 15.646H38.1987L38.1371 15.5747L26.8794 2.58602V15.646H25.4694V0.218018H26.6531L26.7147 0.289351L37.9724 13.278V0.218018H39.3816L39.3824 15.646ZM38.3982 15.2667H38.9697V0.597351H38.3858V14.3633L26.4543 0.597351H25.8821V15.2667H26.4659V1.50069L38.3982 15.2667Z"
                  fill="#303239"
                />
              </g>
              <g id="Group 2847">
                <g id="Path 21362">
                  <path
                    id="Vector_7"
                    d="M44.2707 7.93202C44.1916 3.72933 47.8347 0.263331 52.4069 0.190664C52.4627 0.189998 52.5192 0.189331 52.5751 0.189331C57.2016 0.189331 60.8555 3.59133 60.8555 7.93136C60.8555 12.2714 57.2255 15.674 52.5751 15.674C47.9007 15.674 44.2707 12.272 44.2707 7.93202ZM59.8597 7.93202C59.8597 4.09333 56.6569 1.062 52.5751 1.062C48.47 1.062 45.2672 4.07133 45.2672 7.93202C45.2672 11.7927 48.47 14.8034 52.5751 14.8034C56.6562 14.8034 59.8597 11.7934 59.8597 7.93202Z"
                    fill="#303239"
                  />
                  <path
                    id="Vector_8"
                    d="M52.5751 15.864C47.8042 15.864 44.0669 12.3813 44.0647 7.93467C44.0256 5.85133 44.8712 3.87867 46.4465 2.38C48.0218 0.882 50.1374 0.0373333 52.4039 0.00133333L52.5765 0C57.3343 0 61.063 3.484 61.063 7.932C61.063 12.38 57.3351 15.8647 52.5758 15.8647L52.5751 15.864ZM44.2475 7.932H44.4774C44.4774 12.1673 48.0341 15.4847 52.5751 15.4847C57.116 15.4847 60.6496 12.1667 60.6496 7.93133C60.6496 3.696 57.103 0.379333 52.5751 0.379333L52.4105 0.380667C50.2542 0.414667 48.2408 1.21867 46.7424 2.64467C45.244 4.07067 44.439 5.94733 44.4767 7.92933L44.2468 7.93333L44.2475 7.932ZM52.5751 14.9933C48.3612 14.9933 45.0605 11.892 45.0605 7.932C45.0605 3.972 48.3612 0.872 52.5751 0.872C56.7889 0.872 60.0657 3.97333 60.0657 7.932C60.0657 11.8907 56.7752 14.9933 52.5751 14.9933ZM52.5751 1.25133C48.5933 1.25133 45.4732 4.186 45.4732 7.932C45.4732 11.678 48.5926 14.614 52.5751 14.614C56.5576 14.614 59.653 11.6787 59.653 7.932C59.653 4.18533 56.5438 1.25133 52.5751 1.25133Z"
                    fill="#303239"
                  />
                </g>
                <g id="Path 21363">
                  <path
                    id="Vector_9"
                    d="M71.6434 15.4567H70.8369L63.624 0.408015H64.6677L71.2401 13.9734L77.8118 0.407349H78.8562L71.6427 15.456L71.6434 15.4567Z"
                    fill="#303239"
                  />
                  <path
                    id="Vector_10"
                    d="M71.7776 15.646H70.7013L63.3078 0.218018H64.8019L64.857 0.330684L71.2416 13.5073L77.6784 0.218018H79.1725L71.7776 15.646ZM70.971 15.2667H71.5085L78.54 0.597351H77.946L71.2409 14.44L64.5342 0.597351H63.941L70.9718 15.2667H70.971Z"
                    fill="#303239"
                  />
                </g>
                <g id="Path 21364">
                  <path
                    id="Vector_11"
                    d="M100.535 15.4568H99.5381V0.408081H106.87C109.836 0.408081 111.805 1.97808 111.805 4.35541C111.805 6.73277 109.836 8.30277 106.87 8.30277H105.636L112.66 15.4568H111.283L104.331 8.30277H100.535V15.4568H100.535ZM100.535 1.28008V7.43077H106.87C109.266 7.43077 110.809 6.20941 110.809 4.35541C110.809 2.50141 109.267 1.28008 106.87 1.28008H100.535Z"
                    fill="#303239"
                  />
                  <path
                    id="Vector_12"
                    d="M113.124 15.646H111.191L104.239 8.492H100.741V15.646H99.3322V0.218018H106.87C109.946 0.218018 112.011 1.88069 112.011 4.35535C112.011 6.83 109.945 8.49267 106.87 8.49267H106.1L113.124 15.646ZM111.376 15.2667H112.196L105.172 8.11267H106.87C109.743 8.11267 111.599 6.63735 111.599 4.35469C111.599 2.07202 109.743 0.596684 106.87 0.596684H99.7448V15.266H100.329V8.112H104.423L111.375 15.266L111.376 15.2667ZM106.87 7.62H100.329V1.09069H106.87C109.388 1.09069 111.015 2.37202 111.015 4.35535C111.015 6.33869 109.388 7.62 106.87 7.62ZM100.741 7.24067H106.87C109.137 7.24067 110.602 6.10802 110.602 4.35535C110.602 2.60269 109.137 1.47002 106.87 1.47002H100.741V7.24133V7.24067Z"
                    fill="#303239"
                  />
                </g>
                <g id="Path 21365" transform="translate(246.622, 0) scale(-1, 1)">
                  <path
                    id="Vector_13"
                    d="M123.667 0.407471H122.954L115.363 15.4561H123.804L123.411 14.5621L116.872 14.5808L118.59 11.1821H118.592L119.66 9.07882L123.311 1.82547L126.962 9.07882L128.031 11.1821H128.033L130.192 15.4568H131.259L123.667 0.407471Z"
                    fill="#303239"
                  />
                  <path
                    id="Vector_14"
                    d="M131.583 15.6454H130.061L123.312 2.27674L117.196 14.39L123.551 14.3721L124.109 15.646H115.039L122.822 0.217407H123.799L123.854 0.327407L131.583 15.6454ZM130.324 15.266H130.937L123.536 0.596741H123.086L115.686 15.266H123.498L123.273 14.7514L116.549 14.7707L119.474 8.99804L123.312 1.37341L130.325 15.266H130.324Z"
                    fill="#303239"
                  />
                </g>
                <g id="Path 21366">
                  <path id="Vector_15" d="M82.4174 8.2701H93.332V7.3981L82.4174 7.3761V8.2701Z" fill="#303239" />
                  <path
                    id="Vector_16"
                    d="M93.5387 8.45998H82.2114V7.18665L93.5387 7.20931V8.46065V8.45998ZM82.624 8.08065H93.126V7.58731L82.624 7.56665V8.08065Z"
                    fill="#303239"
                  />
                </g>
                <g id="Rectangle 3823">
                  <path id="Vector_17" d="M94.0442 14.5439H82.4181V15.4019H94.0442V14.5439Z" fill="#303239" />
                  <path
                    id="Vector_18"
                    d="M94.2502 15.5919H82.2114V14.3546H94.2502V15.5919ZM82.624 15.2126H93.8375V14.7339H82.624V15.2126Z"
                    fill="#303239"
                  />
                </g>
                <g id="Path 21367">
                  <path id="Vector_19" d="M82.4174 0.353271V1.22527H94.0428V0.353271H82.4174Z" fill="#303239" />
                  <path
                    id="Vector_20"
                    d="M94.2487 1.41527H82.2106V0.16394H94.2487V1.41527ZM82.6233 1.03594H93.8361V0.543274H82.6233V1.03594Z"
                    fill="#303239"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1173_70151">
          <rect width="132" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
